/*!
 * @license
 * Alfresco Example Content Application
 *
 * Copyright (C) 2005 - 2020 Alfresco Software Limited
 *
 * This file is part of the Alfresco Example Content Application.
 * If the software was purchased under a paid Alfresco license, the terms of
 * the paid license agreement will prevail.  Otherwise, the software is
 * provided under the following open source license terms:
 *
 * The Alfresco Example Content Application is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The Alfresco Example Content Application is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with Alfresco. If not, see <http://www.gnu.org/licenses/>.
 */


import { Action } from '@ngrx/store';
import { CustomSearchOptionModel } from '../../models/custom-search-option.model';

export enum SearchActionTypes {
  // Se debe llamar distinto al original para que no se ejecute tamién
  SearchByTerm = 'ALDEN_SEARCH_BY_TERM'
}


export class SearchByTermAction implements Action {
  readonly type = SearchActionTypes.SearchByTerm;

  /**
 * Constructor de la `SearchByTermAction`.
 * @param {string} payload - Cadena de texto opcional que representa el contenido de la búsqueda.
 * @param {CustomSearchOptionModel[]} searchOptions - Matriz opcional de opciones de búsqueda personalizadas.
 */
  constructor(public payload: string, public searchOptions?: CustomSearchOptionModel[]) {}
}
